
export class Help {
  videoHelpKey?: number;
  title?: string;
  description?: string;
  location?: string;
  videoName?: string;
  videoType?: string;
  nbrVideos?: number;
  subVideoHelp?: Help[];
  video?: any;
  parentVideoHelpKey?: number;

  constructor(parentVideoHelpKey?: number, title?: string, description?: string, videoName?: string) {
    this.parentVideoHelpKey = parentVideoHelpKey;
    this.title = title;
    this.description = description;
    this.videoName = videoName;
  }
}



